export const AppConstants = {


  USUARIOS_TITLE: "Usuarios",
  USUARIOS_SUBTITLE: "Administra los usuarios registrados, puedes seleccionar cualquiera de ellos para consultar o modificar su información, así como crear un nuevo usuario si así lo requiere.",
  USUARIOS_CREATE_TITLE: "Crear usuario",
  USUARIOS_CREATE_SUBTITLE: "Completa sus datos para registrarlo",
  USUARIOS_EDIT_TITLE: "Editar usuario",
  USUARIOS_EDIT_SUBTITLE: "Actualiza su información y da click en Guardar al finalizar",

  CLIENTS_TITLE: "Clientes",
  CLIENTS_SUBTITLE: "Administra los clientes registrados, puedes seleccionar cualquiera de ellos para consultar o modificar su información, así como crear un nuevo usuario si así lo requiere.",
  CLIENTS_CREATE_TITLE: "Crear cliente",
  CLIENTS_CREATE_SUBTITLE: "Completa sus datos para registrarlo",
  CLIENTS_EDIT_TITLE: "Editar cliente",
  CLIENTS_EDIT_SUBTITLE: "Actualiza su información y da click en Guardar al finalizar",

  OCCUPATION_TITLE: "Ocupación",
  OCCUPATION_SUBTITLE: "Posición que ocupa un empleado y las actividades que le son asignadas.",

  DEPARTAMENT_TITLE: "Departamento",
  DEPARTAMENT_SUBTITLE: "División interna de una empresa que se enfoca en un área particular de actividad.",


  CAMPANAS_TITLE: "Campañas",
  CAMPANAS_SUBTITLE: "Selecciona una campaña para acceder a su información y configuración.",
  CAMPANAS_FORM_TITLE_CREATE: "Crear campaña",
  CAMPANAS_FORM_SUBTITLE_CREATE: "Completa la información para crear campaña",
  CAMPANAS_FORM_TITLE_EDIT: "Editar campaña",
  CAMPANAS_FORM_SUBTITLE_EDIT: "Actualiza su información y da click en Guardar al finalizar",
  CAMPANAS_TITLE_TOKEN: "Generar tokens",
  CAMPANAS_SUBTITLE_TOKEN: "Da click en el botón para confirmar la información y procesar tokens",
  CAMPANAS_TITLE_GENERATED_TOKENS: "Tokens",
  CAMPANAS_SUBTITLE_GENERATED_TOKENS: "A continuación se muestra un listado de los tokens que se generaron. puedes exportarlos en formato .CSV o Excel.",
  CAMPANAS_MODAL_CARGA_TITLE:"Generando tokens",
  CAMPANAS_MODAL_CARGA_SUBTITLE: "Por favor, espera unos momentos  este proceso puede tardar unos segundos. No cierres ni recargues la página.",

  RESULTADOS_TITLE: "Resultados",
  RESULTADOS_SUBTITLE: "Bienvenido al sistema de gestión NOM-035",

};
